import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';
import { Map } from 'immutable';

const MY_ID = 'my';

const sanitise = ({skillAcquired, skillExpiry, validFrom, ...rest}) => ({
    ...rest,
    skillAcquired:  (skillAcquired && new Date(skillAcquired)),
    skillExpiry:    (skillExpiry && new Date(skillExpiry)),
    validFrom:      (validFrom && new Date(validFrom)),
});

class CourseComplianceStoreStore extends ReduceStore {

    getInitialState() {
        return Map();
    }

    get(key) {
        return this.getState().get(key);
    }

    getMy() {
        return this.getState().get(MY_ID);
    }

    has(key) {
        return this.getState().has(key);
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.COURSE_COMPLIANCE_LIST_REQUEST:
                return state;

            case ActionTypes.COURSE_COMPLIANCE_LIST_SUCCESS:
                return this.getState().set(action.payload.userId || MY_ID, action.data.map(sanitise));

            default:
                return state;
        }
    }
}


export default new CourseComplianceStoreStore(CentricDispatcher);

